// alb-frontend/src/pages/order-confirmed/index.js

import React from 'react';
import { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import { Logo } from '../../components/Logo'; 
import CosmicBackground from '../../assets/images/life-journey/cosmic-background.jpg';
import { trackReportEvent } from "../../utils/analytics";

const OrderConfirmed = () => {
    const location = useLocation();
    const { orderId, plan, finalAmount } = location.state || {}; // Safely access state

    useEffect(() => {
    if (plan && orderId && finalAmount) {
        console.log('plan.title',plan.title);
        console.log('plan.id',plan.id);
        console.log('finalAmount',finalAmount);
        console.log('orderId',orderId);
        trackReportEvent("purchase", {
        reportName: plan.title,
        reportId: plan.id,
        price: finalAmount,
        orderId: orderId,
        });
    }
    }, [plan, orderId, finalAmount]);

    // Fallback UI if state is missing
    if (!orderId || !plan) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-[#0D0B14] text-white p-6">
                <Logo />
                <h1 className="text-2xl font-bold text-red-500 mt-8">Oops! Something went wrong.</h1>
                <p className="text-gray-400 mt-2">We couldn't find your order details.</p>
                <Link to="/">
                    <Button variant="cosmic" size="lg" className="mt-6">
                        Return to Homepage
                    </Button>
                </Link>
            </div>
        );
    }

    return (
        <div
            className="min-h-screen bg-cover bg-center text-white flex items-center justify-center p-4"
            style={{ backgroundImage: `url(${CosmicBackground})` }}
        >
            <Card className="w-full max-w-md bg-midnight-purple/80 backdrop-blur-sm border-cosmic-gold/20 text-center p-8">
                <CardHeader>
                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-500">
                        <CheckCircle2 className="h-6 w-6 text-white" />
                    </div>
                    <CardTitle className="text-3xl font-bold text-cosmic-gold mt-4">
                        Thank You For Your Order!
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <p className="text-stardust-silver">
                        Your payment was successful. Our team will now begin preparing your personalized report.
                    </p>
                    
                    {/* Order Summary from original file */}
                    <div className="text-left bg-black/20 rounded-lg p-4 my-6 border border-cosmic-gold/20">
                        <h2 className="text-lg font-semibold mb-3 text-cosmic-gold">Order Summary</h2>
                        <div className="space-y-2">
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-400">Order ID:</span>
                                <span className="font-mono text-white">{orderId}</span>
                            </div>
                            <div className="flex justify-between text-sm">
                                <span className="text-gray-400">Plan:</span>
                                <span className="font-semibold text-white">{plan.title}</span>
                            </div>
                            <div className="flex justify-between items-baseline pt-2 border-t border-cosmic-gold/20 mt-2">
                                <span className="text-gray-400">Amount Paid:</span>
                                <div>
                                    <span className="font-bold text-xl text-white">₹{finalAmount}</span>
                                    <span className="text-xs text-gray-400 line-through ml-2">₹{plan.originalPrice}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Link to="/">
                        <Button variant="cosmic" size="lg" className="mt-6 w-full">
                            Return to Home Page
                        </Button>
                    </Link>
                </CardContent>
            </Card>
        </div>
    );
};

export default OrderConfirmed;